var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:this.classObject,attrs:{"disabled":this.disabled},on:{"click":_vm.clickHandler}},[(!this.showWaitText)?_vm._t("default"):_vm._e(),_vm._v(" "),(this.showWaitText)?_c('span',[_vm._v(_vm._s(this.waitText)+"..")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }